import React, { useEffect, useState, useMemo } from "react";
import moment from "moment";
import useHttp from "../../hooks/use-http";
import { Bar, Column, Line, Pie } from "@ant-design/plots";
import { Card, Typography } from "antd";
import AreaCovered from "../../components/Dashboard/AreaCovered";
import CropWise from "../../components/Dashboard/Procurement/CropWise";
import FieldExecutive from "../../components/Dashboard/FieldExecutive";

const { Title, Text } = Typography;

const ProcurementDashboard = () => {
  const [data, setData] = useState([]);
  const [landData, setLandData] = useState([]);
  const [ranchData, setRanchData] = useState([]);
  const [cropData, setCropData] = useState([]);
  const [cropArea, setCropArea] = useState(0);
  const [taskData, setTaskData] = useState([]);
  const [weatherData, setWeatherData] = useState("");
  const [currentDay, setCurrentDay] = useState("");
  const [currentDate, setCurrentDate] = useState("");
  const [todaysHarvest, setTodaysHarvest] = useState([]);
  const [isAccess, setIsAccess] = useState(0);
  const [showAllCrop, setShowAllCrop] = useState(false);
  const [showAllRanch, setShowAllRanch] = useState(false);

  const { sendRequest: getData } = useHttp();
  const [showAllSeason, setShowAllSeason] = useState(false);
  const orgId = Number(localStorage.getItem("orgId"));
  const [harvestData, setHarvestData] = useState([]);

  const input = [
    { date: "Jan 5", type: "Profit", value: 15000 },
    { date: "Jan 5", type: "Loss", value: -8000 },
    { date: "Jan 8", type: "Profit", value: 30000 },
    { date: "Jan 8", type: "Loss", value: -6000 },
    { date: "Jan 10", type: "Profit", value: 20000 },
    { date: "Jan 10", type: "Loss", value: -9000 },
    { date: "Jan 13", type: "Profit", value: 55000 },
    { date: "Jan 13", type: "Loss", value: -28000 },
    { date: "Jan 15", type: "Profit", value: 78000 },
    { date: "Jan 15", type: "Loss", value: -12000 },
    { date: "Jan 17", type: "Profit", value: 68000 },
    { date: "Jan 17", type: "Loss", value: -15000 },
    { date: "Jan 20", type: "Profit", value: 15000 },
    { date: "Jan 20", type: "Loss", value: -5000 },
    { date: "Jan 23", type: "Profit", value: 10000 },
    { date: "Jan 23", type: "Loss", value: -6000 },
    { date: "Jan 25", type: "Profit", value: 36000 },
    { date: "Jan 25", type: "Loss", value: -20000 },
    { date: "Jan 28", type: "Profit", value: 50000 },
    { date: "Jan 28", type: "Loss", value: -8000 },
  ];

  const config11 = {
    data: input,
    isGroup: true,
    xField: "date",
    yField: "value",
    seriesField: "type",
    color: ({ type }) => (type === "Profit" ? "#3b82f6" : "#22c55e"),
    columnStyle: { radius: [4, 4, 0, 0] },
    label: false,
    legend: {
      position: "top",
    },
    tooltip: {
      formatter: (item) => ({
        name: item.type,
        value: item.value.toLocaleString(),
      }),
    },
  };

  useEffect(() => {
    getData(
      {
        url: `/api/webdashBoardTmjoSummary/?orgId=${localStorage.getItem(
          "orgId",
        )}&userId=${localStorage.getItem("id")}&tdate=${moment().format(
          "DD/MM/YYYY",
        )}`,

      },
      (res) => {
        // console.log("Api res", res);
        setLandData(res.landArea);
        setCropData(res.cropwiseadistribution);
        setTodaysHarvest(res.todaysHarvest);

        const totalAreaSum =
          res &&
          res.cropwiseadistribution.reduce(
            (sum, crop) => sum + crop.totalArea,
            0,
          );
        //   console.log(totalAreaSum);
        setCropArea(totalAreaSum);

        setTaskData(res.todaysPlanTask);

        setData(res);
      },
    );
  }, [getData]);

  useEffect(() => {
    getData(
      {
        url: `/api/webRanchAreaTmjoSummary/?orgId=${localStorage.getItem(
          "orgId"
        )}&userId=${localStorage.getItem("id")}&tdate=${moment().format(
          "DD/MM/YYYY"
        )}`,

      },
      (res) => {
        //   console.log(res);

        setRanchData(res.ranchAreaDistribution);

        const totalAreaSum =
          res &&
          res.cropwiseadistribution.reduce(
            (sum, crop) => sum + crop.totalArea,
            0
          );
        //   console.log(totalAreaSum);
        setCropArea(totalAreaSum);

        setTaskData(res.todaysPlanTask);

        setData(res);
      }
    );
  }, [getData]);


  useEffect(() => {
    getData(
      {
        url: `/api/VehicleWeighbridgeFarmerReport/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem("id")}`,

      },
      (res) => {
        console.log("Harvest API:", res);
        const groupedData = {};

        res.forEach((item) => {
          const key = `${item.ranchName}_${item.cropName}`;

          if (!groupedData[key]) {
            groupedData[key] = {
              ranchName: item.ranchName,
              cropName: item.cropName,
              grandTotal: 0,
              areaOfPlot: 0,
              areaUnit: item.areaUnit,
              averageHarvest: 0
            };
          }


          groupedData[key].grandTotal += (item.grandTotal || 0) / 1000; // Converted from Kg to MT
          groupedData[key].areaOfPlot += item.areaOfPlot || 0;
        });


        Object.values(groupedData).forEach((item) => {
          item.averageHarvest =
            item.areaOfPlot > 0
              ? item.grandTotal / item.areaOfPlot
              : 0;
        });

        const finalData = Object.values(groupedData);
        setHarvestData(finalData);
      }
    );
  }, [getData]);



  const getWeatherData = async (latitude, longitude) => {
    try {
      const response = await fetch(
        `https://api.weatherapi.com/v1/current.json?q=${latitude},${longitude}&key=d91f9b463dfb40c8873110928231506`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );

      // console.log(response);

      if (response.ok) {
        const res = await response.json();
        // console.log(res);
        setWeatherData(res.current || "");
      } else {
        console.error(`Error: ${response.statusText}`);
      }
    } catch (error) {
      console.error("Error during fetch:", error.message);
    }
  };

  useEffect(() => {
    const today = new Date();

    const dayOptions = { weekday: "long" };
    const dayName = today.toLocaleDateString("en-US", dayOptions);

    const dateOptions = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = today.toLocaleDateString("en-US", dateOptions);

    setCurrentDay(dayName);
    setCurrentDate(formattedDate);

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;
          getWeatherData(latitude, longitude);
          // console.log(weatherData.condition);
        },
        (error) => {
          console.error("Error getting geolocation:", error);
        },
      );
    } else {
      console.error("Geolocation is not supported by your browser");
    }
  }, []);

  const generateColorMap = (cropData) => {
    const colors = [
      "#7fff00",
      "#d2691e",
      "#ff7f50",
      "#DFFF00",
      "#FFBF00",
      "#DE3163",
      "#6495ED",
      "#CCCCFF",
      "#a52a2a",
      "#deb887",
      "#5f9ea0",
    ];
    const colorMap = {};
    cropData.forEach((crop, index) => {
      colorMap[crop.cropName] = colors[index % colors.length];
    });
    return colorMap;
  };

  const colorMap = useMemo(() => generateColorMap(cropData), [cropData]);

  const getColor = (crop) => {
    return colorMap[crop.cropName] || "#ccc";
  };

  const pieData = cropData.map((crop) => ({
    type: crop.cropName,
    value: crop.totalArea,
  }));

  const config = {
    appendPadding: 10,
    data: pieData,
    angleField: "value",
    colorField: "type",
    radius: 0.9,
    label: {
      type: "outer",
      content: "{name} {percentage}",
    },
    interactions: [
      {
        type: "element-active",
      },
    ],
  };

  const visibleSeasonData = showAllSeason
    ? data?.seasonSummary || []
    : data?.seasonSummary?.slice(0, 3) || [];
  const visibleCropData = showAllCrop
    ? data?.cropwiseadistribution || []
    : data?.cropwiseadistribution?.slice(0, 3) || [];

  const visibleRanchData = showAllRanch
    ? ranchData || []
    : ranchData?.slice(0, 5) || [];

  return (
    <>

      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6"></div>

              <div className="col-sm-6"></div>
            </div>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 col-sm-6 col-md-4">
                <div
                  className="info-box mb-3"
                  style={{ backgroundColor: "#4E6E81", overflow: "hidden", minHeight: "240px", borderRadius: "12px", border: "none" }}
                >
                  <div className="info-box-content">
                    <label className="info-box-text text-light">Farmer Summary</label>

                    <table className="table table-sm text-white text-center">
                      <thead>
                        <tr>
                          <th>Season</th>
                          <th>Farmer</th>
                          <th>Area</th>
                        </tr>
                      </thead>
                      <tbody>
                        {visibleSeasonData.length > 0 ? (
                          visibleSeasonData.map((item, index) => (
                            <tr key={index}>
                              <td>{item.seasonName}</td>
                              <td>{item.farmerCount}</td>
                              <td>
                                {item.totalArea} {landData?.landUnit}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="3">No Data Available</td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    {data?.seasonSummary?.length > 2 && (
                      <span
                        onClick={() => setShowAllSeason(!showAllSeason)}
                        style={{
                          cursor: "pointer",
                          fontSize: "12px",
                          color: "#e6e6e6",
                          display: "block",
                          textAlign: "center",
                          marginTop: "2px",
                        }}
                      >
                        {showAllSeason ? "less..." : "more..."}
                      </span>
                    )}
                  </div>
                </div>
                {/* <div className="info-box mb-3 bg-info">
                  <div className="info-box-content">
                    <label className="info-box-text">Todays Harvest</label>
                    <div className="row">

                    <table className="table table-bordered text-center">
                          <thead>
                            <tr>
                            <th>Crop </th>
                              <th>Quantity</th>
                              <th>Amount</th>
                           
                            </tr>
                          </thead>
                          <tbody>
                            {todaysHarvest &&
                              todaysHarvest.map((x, i) => (
                                <tr key={i}>
                                    <td>{x.cropName}</td>
                                  <td>{x.totalQuantity}&nbsp;{x.unitAbbreviation}</td>
                                  <td>{x.totalAmount}</td>
                            
  
                                   
                                   
                                </tr>
                              ))}
                          </tbody>
                        </table>


                       
                    </div>
                  </div>
                </div> */}
              </div>

              <div className="col-12 col-sm-6 col-md-4">
                <div
                  className="info-box mb-3"
                  style={{ backgroundColor: "#73aacf", overflow: "hidden", minHeight: "240px", borderRadius: "12px", border: "none" }}
                >
                  <div className="info-box-content">
                    <label className="info-box-text text-light">Crop Summary</label>

                    <table className="table table-sm text-white text-center">
                      <thead>
                        <tr>
                          <th>Crops</th>
                          <th>Sown</th>
                        </tr>
                      </thead>
                      <tbody>
                        {visibleCropData.length > 0 ? (
                          visibleCropData.map((item, index) => (
                            <tr key={index}>
                              <td>{item.cropName}</td>
                              <td>
                                {item.totalArea} {landData?.landUnit}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="2">No Data Available</td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    {data?.cropwiseadistribution?.length > 3 && (
                      <span
                        onClick={() => setShowAllCrop(!showAllCrop)}
                        style={{
                          cursor: "pointer",
                          fontSize: "12px",
                          color: "#e6e6e6",
                          display: "block",
                          textAlign: "center",
                          marginTop: "2px",
                        }}
                      >
                        {showAllCrop ? "less..." : "more..."}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              {orgId === 2 && (
                <div className="col-12 col-sm-6 col-md-4">
                  <div
                    className="info-box mb-3"
                    style={{ backgroundColor: "#4f494f", overflow: "hidden", minHeight: "240px", borderRadius: "12px", border: "none" }}
                  >
                    <div className="info-box-content">
                      <label className="info-box-text text-light">Total Harvest</label>

                      <table className="table table-sm text-white text-center">
                        <thead>
                          
                        </thead>

                        <tbody>
                          
                          
                        </tbody>
                      </table>

                      {ranchData?.length > 2 && (
                        <span
                          onClick={() => setShowAllRanch(!showAllRanch)}
                          style={{
                            cursor: "pointer",
                            fontSize: "12px",
                            color: "#e6e6e6",
                            display: "block",
                            textAlign: "center",
                            marginTop: "2px",
                          }}
                        >
                          {showAllRanch ? "less..." : "more..."}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {orgId === 3 && (
                <div className="col-12 col-sm-6 col-md-4">
                  <div
                    className="info-box mb-3"
                    style={{ backgroundColor: "#af6092", overflow: "hidden", minHeight: "240px", borderRadius: "12px", border: "none" }}
                  >
                    <div className="info-box-content">
                      <label className="info-box-text text-light">Ranch Summary</label>

                      <table className="table table-sm text-white text-center">
                        <thead>
                          <tr>
                            <th>Ranch Name</th>
                            <th>Crops</th>
                            <th>Sown</th>
                          </tr>
                        </thead>

                        <tbody>
                          {visibleRanchData.length > 0 ? (
                            visibleRanchData.map((item, index) =>
                              item.crops && item.crops.length > 0 ? (
                                item.crops.map((crop, cropIndex) => (
                                  <tr key={`${index}-${cropIndex}`}>
                                    {cropIndex === 0 && (
                                      <td rowSpan={item.crops.length}>{item.ranchName}</td>
                                    )}
                                    <td>{crop.cropName}</td>
                                    <td>{crop.totalArea} {crop.unitAbbreviation}</td>
                                  </tr>
                                ))
                              ) : (
                                <tr key={index}>
                                  <td>{item.ranchName}</td>
                                  <td colSpan="2">No Crops</td>
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td colSpan="3">No Data Available</td>
                            </tr>
                          )}
                        </tbody>
                      </table>

                      {ranchData?.length > 2 && (
                        <span
                          onClick={() => setShowAllRanch(!showAllRanch)}
                          style={{
                            cursor: "pointer",
                            fontSize: "12px",
                            color: "#e6e6e6",
                            display: "block",
                            textAlign: "center",
                            marginTop: "2px",
                          }}
                        >
                          {showAllRanch ? "less..." : "more..."}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              )}


            </div>
            <div className="row">
              {orgId === 3 && (
                <div className="col-md-8">
                  <div
                    className="info-box"
                    style={{ backgroundColor: "#3ca05d", overflow: "hidden", minHeight: "250px", borderRadius: "12px", border: "none" }}
                  >
                    <div className="info-box-content">
                      <label className="info-box-text text-light">Total Harvest</label>

                      <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                        <table className="table table-sm text-white text-center">
                          <thead>
                            <tr>
                              <th>Ranch Name</th>
                              <th>Crop</th>
                              <th>Quantity Harvested (MT)</th>
                              <th>Area (ha)</th>
                              <th>Avg Harvest (MT/ha)</th>
                            </tr>
                          </thead>

                          <tbody>
                            {harvestData === null ? (
                              <tr>
                                <td colSpan="5">Loading...</td>
                              </tr>
                            ) : harvestData.length === 0 ? (
                              <tr>
                                <td colSpan="5">Loading...</td>
                              </tr>
                            ) : (
                              harvestData.map((item, index) => (
                                <tr key={item.vehicleWeighBridgeFarmerId || index}>
                                  <td>{item.ranchName}</td>
                                  <td>{item.cropName}</td>
                                  <td>{item.grandTotal?.toFixed(2)}</td>
                                  <td>
                                    {item.areaOfPlot?.toFixed(2)} {item.areaUnit}
                                  </td>
                                  <td>{item.averageHarvest?.toFixed(2)}</td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* <div className="col-12 col-sm-6 col-md-4">
                <div className="info-box bg-dark" style={{ overflow: "hidden", minHeight: "210px" }}>
                  <div className="info-box-content">
                    <label className="info-box-text">Total Harvest</label>
                    <div className="row text-center">
                      <div className="col-12 col-sm-12 col-md-6">
                        <br />{" "}
                        <table className="table table-sm text-white text-center">
                          <thead>
                            <tr>
                              <th>Ranch Name</th>
                              <th>Crop</th>
                              <th>Quantity Harvested</th>
                              <th>Area</th>
                            </tr>
                          </thead>
                          <tbody>
                            {harvestData && harvestData.length > 0 ? (
                              harvestData.map((item, index) => (
                                <tr key={index}>
                                  <td>{item.ranchName}</td>
                                  <td>{item.cropName}</td>
                                  <td>{item.grandTotal}</td>
                                  <td>{item.areaOfPlot}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="3">No Data Available</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6">
                        <br />
                        <label>
                          <br />
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}

            {/* <div className="row">
              <div className="col-12 col-sm-6 col-md-12">
                <div className="card card-primary shadow">
                  <div className="card-header">
                    <h3 className="card-title">Area Covered Per Ranch</h3>
                  </div>
                  <div className="card-body">
                    <div style={{ width: "80%" }}>
                        <AreaCovered />
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div className="row">
              <div className="col-12 col-sm-6 col-md-12">
                <div className="card card-primary shadow">
                  <div className="card-header">
                    <h3 className="card-title">Crop Wise Per Region</h3>
                  </div>
                  <div className="card-body">
                    <div style={{ width: "80%" }}>
                        <CropWise />
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div className="row">
              <div className="col-12 col-sm-6 col-md-12">
                <div className="card card-primary shadow">
                  <div className="card-header">
                    <h3 className="card-title">Field Executive Per Region</h3>
                  </div>
                  <div className="card-body">
                    <div style={{ width: "80%" }}>
                        <FieldExecutive />
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </section>
      </div>
    </>
  );
};

export default ProcurementDashboard;

